module.exports = __webpack_public_path__ + "img/box1.a818b01f.png";